// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__wSDAY","fav_total":"Nav_fav_total__ICp0V"};